import { render, staticRenderFns } from "./ContactInfoAddress.vue?vue&type=template&id=885898bc&scoped=true"
import script from "./ContactInfoAddress.vue?vue&type=script&lang=ts"
export * from "./ContactInfoAddress.vue?vue&type=script&lang=ts"
import style0 from "./ContactInfoAddress.vue?vue&type=style&index=0&id=885898bc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885898bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('885898bc')) {
      api.createRecord('885898bc', component.options)
    } else {
      api.reload('885898bc', component.options)
    }
    module.hot.accept("./ContactInfoAddress.vue?vue&type=template&id=885898bc&scoped=true", function () {
      api.rerender('885898bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contacts/ContactInfoAddress.vue"
export default component.exports